var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-select',_vm._g(_vm._b({attrs:{"options":_vm.options},scopedSlots:_vm._u([{key:"read_only",fn:function(){return [_vm._t("read_only")]},proxy:true},{key:"label",fn:function(){return [_vm._t("label")]},proxy:true},{key:"hint",fn:function(){return [_vm._t("hint")]},proxy:true}],null,true)},'form-select',_vm.select_props,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }